import { EV4bClientErrorCategory } from "@/data/api/kili/common/kili-errors.type";

export interface V4bDomainApiError {
  errorCategory: EV4bClientErrorCategory.DOMAIN_ERROR;
  errorDetails?: {
    errorType?: string;
    errorCode?: string;
    message?: string;
  };
}

export interface V4bTechnicalApiError {
  errorCategory: EV4bClientErrorCategory.TECHNICAL_ERROR;
  errorDetails?: {
    errorType?: string;
    errorCode?: string;
    message?: string;
  };
}

export interface V4bFormFieldApiError {
  errorCode?: string;
  message: string;
  propertyPath?: string;
}

export interface V4bFormValidationApiError {
  errorCategory: EV4bClientErrorCategory.FORM_VALIDATION_ERROR;
  errorDetails?: {
    fieldErrors?: Array<V4bFormFieldApiError>;
  };
}

export interface V4bUnexpectedApiError {
  errorCategory: EV4bClientErrorCategory.UNEXPECTED_ERROR;
  errorDetails?: {
    errorType?: string;
    message?: string;
  };
}

export interface V4bHttpReadApiError {
  errorCategory: EV4bClientErrorCategory.HTTP_READ_ERROR;
  errorDetails?: {
    message?: string;
  };
}

export type V4bApiError =
  | V4bDomainApiError
  | V4bTechnicalApiError
  | V4bFormValidationApiError
  | V4bUnexpectedApiError
  | V4bHttpReadApiError;

export class V4bClientUnknownError extends Error {
  constructor(
    public readonly request: Request,
    public readonly response: Response,
  ) {
    super("V4b client unknown error");
    this.name = "V4bClientUnknownError";
  }
}

export class V4bClientError extends Error {
  constructor(
    public readonly request: Request,
    public readonly response: Response,
    public readonly error: V4bApiError,
  ) {
    super("V4b client error");
    this.name = "V4bClientError";
  }
}
